var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"release",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.onSelect('/Tasting/wine/Release')}}},[_c('div',{staticClass:"iconfont iconxiangji border-color font-color"}),_c('div',{staticClass:"fabu-font"},[_vm._v("发表")])])
}
var staticRenderFns = []

export { render, staticRenderFns }